import { Injectable } from '@angular/core';
import { SecureApi } from '../core/secure.api';

@Injectable()

export class NotificationsService {

    constructor(public secureApi: SecureApi) {
    }

    deleteNotification(notificationId) {
        return this.secureApi.delete('notifications/delete/' + notificationId);
    }

}
